import RecoverPasswordFormTab from "ui/auth/containers/RecoverPasswordTabs/RecoverPasswordFormTab/RecoverPasswordFormTab";
import SuccessTab from "ui/auth/containers/RecoverPasswordTabs/SuccessTab/SuccessTab";
import { StatefulTab } from "ui/common/components/navigation/StatefulTabs/StatefulTabs.types";

export const RECOVER_PASSWORD_TABS: StatefulTab[] = [
    {
        content: <RecoverPasswordFormTab />,
    },
    {
        content: <SuccessTab />,
    },
];
